import React, { useState, useEffect } from 'react';
import { useForm } from '@mantine/form';
import { TextInput, Button, Group, Title, createStyles, Box, Image, Text } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { saveParticipatingCity, updateParticipatingCity, getProvinces } from '../../services/api.service';
import { IconCheck } from '@tabler/icons-react';
import ImageDropzone from '../imageDropzone/ImageDropzone';
import { Select } from '@mantine/core';

const useStyles = createStyles((theme) => ({
	imageContainer: {
		border: '1px solid #CCCCCC',
		padding: 3,
		borderRadius: theme.radius.sm,
	}
}));

const CityForm = ({ closeModal, isEdit, city }) => {
	const [isLoading, toggleLoading] = useState(false);
	const [fileURL, setFileURL] = useState('');
	const [isLogoChanged, toggleIsLogoChanged] = useState(false);
	const [provinces, setProvinces] = useState([]);
	const { classes } = useStyles();

	const form = useForm({
		initialValues: {
			name: '',
			province: {
				id: '',
				name: '',
			},
			file: null,
		},
		validate: {
			name: (value) => (value ? null : 'Este campo es requerido'),
			file: (value) => (!isEdit && !value ? 'La imagen es requerida' : null),
		  },
	});

	useEffect(() => {
		if (isEdit) {
			form.setValues({
				name: city.name,
				province: city.province,
				file: city.file,
			});
		}
		// eslint-disable-next-line
	}, []);


	// Get provinces
	useEffect(() => {
		// Get partners
		getProvinces(function (response) {
			// Loop provinces
			var provinces = [];
			for (var i = 0; i < response.data.length; i++) {

				// Assign
				provinces.push({
					label: response.data[i].name,
					value: response.data[i].id,
				});
			}
			// Set state
			setProvinces(provinces);
		}, function (error) {
			// Show error
			notifications.show({
				title: 'Error',
				message: error,
				color: 'red'
			});
		});
	}, []);

	// Submit form
	const onSubmit = (values) => {
		toggleLoading(true);

		// Conditions
		if (!isEdit) {

			// Call API
			saveParticipatingCity(values, function () {
				notifications.show({
					title: 'Ciudad creada correctamente',
					color: 'green',
					icon: <IconCheck />
				});
				setTimeout(() => {
					closeModal();
				}, 1000);

			}, function (error) {
				toggleLoading(false);
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		} else {

			// Call API
			updateParticipatingCity(city.id, values, function () {
				notifications.show({
					title: 'Ciudad modificada correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				setTimeout(() => {
					closeModal();
				}, 1000);

			}, function (error) {
				toggleLoading(false);
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});
		}
	}

	const onDrop = (file) => {
		form.setFieldValue('file', file[0]);
		setFileURL(URL.createObjectURL(file[0]));
		toggleIsLogoChanged(true);
	};

	const onReject = () => {
		notifications.show({
			title: 'Error',
			message: 'Este tipo de archivo no está soportado.',
			color: 'red'
		});
	};

	return (
		<form onSubmit={form.onSubmit(onSubmit)}>
			<Title order={5} mb="md">
				{isEdit ? 'Modificar' : 'Crear'} Información de la ciudad
			</Title>

			<Group grow>
				<TextInput
					required
					label="Nombre"
					placeholder="Nombre de la ciudad"
					value={form.values.name}
					onChange={(event) => form.setFieldValue('name', event.currentTarget.value)}
					{...form.getInputProps('name')}
				/>
			</Group>

			<Group grow mt="md">
				{/* Province */}
				<Select
					searchable
					withinPortal
					required
					label="Provincia"
					placeholder="Busca una provincia"
					value={form.values.province.id}
					onChange={(event) => form.setFieldValue('province.id', event.currentTarget.value)}
					{...form.getInputProps('province.id')}
					nothingFound="Sin resultados"
					data={provinces}
				/>
			</Group>

			<Title order={5} mb="md" mt="lg">Imagen <span style={{ color: 'red', fontWeight: '100', lineHeight: '1.5' }}>*</span></Title>
			<Group>
                <ImageDropzone onDrop={onDrop} onReject={onReject} instruction="Sube la imagen de esta ciudad"/>
				{(form.values.file || (isEdit && city.image)) && (
                  <Box className={classes.imageContainer}>
                    <Image
                      withPlaceholder
                      src={
                        isLogoChanged && fileURL
                          ? fileURL
                          : isEdit && city.image
                          ? city.image
                          : undefined
                      }
                      imageProps={
                        isLogoChanged && fileURL
                          ? { onLoad: () => URL.revokeObjectURL(fileURL) }
                          : undefined
                      }
                      height={148}
                      width={148}
                      radius="sm"
                    />
                  </Box>
                )}
			</Group>
			{form.errors.file && (
			  <Text color="red" size="xs" mt={5}>
			    {form.errors.file}
			  </Text>
			)}
			<Group position="apart" grow={!isEdit}>
				<Button
					mt="xl"
					color="red"
					onClick={closeModal}
					disabled={isLoading}
					variant="light"
					sx={{ flexGrow: isEdit ? 2 : 1 }}
				>
					Cancelar
				</Button>
				<Button
					mt="xl"
					type="submit"
					loading={isLoading}
					variant="filled"
					sx={{ flexGrow: isEdit ? 2 : 1 }}
				>
					{isEdit ? 'Guardar Cambios' : 'Crear Ciudad'}
				</Button>
			</Group>
		</form>
	);
};

export default CityForm;
